import { ReactNode, useState } from 'react'

import Button from '../app/design/Button'
import Modal from '../app/design/Modal'
import { SelectList, SelectListItem, Props as SelectListProps } from './SelectList'

type Props<ItemType extends SelectListItem> = Omit<SelectListProps<ItemType>, 'onSelectItems'> & {
    isOpen: boolean
    onClose: () => void
    onDone?: () => void
    title?: string
    emptyView?: ReactNode
    onSelectItems?: (items: ItemType[]) => Promise<void> | void
}

export const SelectModal = <ItemType extends SelectListItem>({
    isOpen,
    onClose,
    onDone,
    selectionType,
    items,
    selectedItems,
    onSelectItems,
    canSearch,
    title,
    emptyView,
}: Props<ItemType>) => {
    const [isLoading, setIsLoading] = useState(false)

    const handleSelectItems = async (items: ItemType[]) => {
        const response = onSelectItems?.(items)
        if (!(response instanceof Promise)) {
            return
        }

        setIsLoading(true)
        await response
        setIsLoading(false)
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            footer={
                <Button
                    intent="primary"
                    onClick={!!onDone ? onDone : onClose}
                    disabled={!!onDone && selectedItems.length === 0}
                    isLoading={isLoading}
                >
                    Done
                </Button>
            }
        >
            {emptyView !== undefined && items.length === 0 ? (
                emptyView
            ) : (
                <SelectList
                    selectionType={selectionType}
                    items={items}
                    selectedItems={selectedItems}
                    onSelectItems={handleSelectItems}
                    canSearch={canSearch}
                />
            )}
        </Modal>
    )
}
